// extracted by mini-css-extract-plugin
export var label = "_rh-0";
export var link = "_rh-1";